module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.mod === 'default') ? _c('div', {
    staticClass: " weex-ct weex-div",
    class: ['wxc-search-bar', 'wxc-search-bar-' + _vm.theme],
    style: (_vm._px2rem(_vm.barStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('input', {
    ref: "search-input",
    class: ['search-bar-input', 'search-bar-input-' + _vm.theme],
    style: ({
      width: _vm._px2rem(_vm.needShowCancel ? '624px' : '710px', 75)
    }),
    attrs: {
      "return-key-type": _vm.returnKeyType,
      "autofocus": _vm.autofocus,
      "disabled": _vm.disabled,
      "type": _vm.inputType,
      "placeholder": _vm.placeholder,
      "data-evt-blur": "",
      "data-evt-focus": "",
      "data-evt-input": "",
      "data-evt-return": ""
    },
    domProps: {
      "value": _vm.value
    },
    nativeOn: {
      "blur": function($event) {
        $event.stopPropagation();
        return _vm.onBlur($event)
      },
      "focus": function($event) {
        $event.stopPropagation();
        return _vm.onFocus($event)
      },
      "input": function($event) {
        $event.stopPropagation();
        return _vm.onInput($event)
      },
      "return": function($event) {
        $event.stopPropagation();
        return _vm.onSubmit($event)
      }
    }
  }), _vm._v(" "), (_vm.disabled) ? _c('div', {
    staticClass: "disabled-input weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.inputDisabledClicked($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('figure', {
    staticClass: "search-bar-icon weex-el weex-image",
    attrs: {
      "aria-hidden": true,
      "src": _vm.inputIcon,
      "data-img-src": _vm.inputIcon,
      "weex-type": "image"
    }
  }), _vm._v(" "), (_vm.showClose) ? _c('figure', {
    staticClass: "search-bar-close weex-el weex-image",
    attrs: {
      "aria-hidden": true,
      "src": _vm.closeIcon,
      "data-img-src": _vm.closeIcon,
      "weex-type": "image",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.closeClicked($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.needShowCancel) ? _c('p', {
    staticClass: " weex-el weex-text",
    class: ['search-bar-button', 'search-bar-button-' + _vm.theme],
    style: (_vm._processExclusiveStyle(_vm.buttonStyle, 75, 'text')),
    attrs: {
      "weex-type": "text",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.cancelClicked($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.cancelLabel))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mod === 'hasDep') ? _c('div', {
    staticClass: " weex-ct weex-div",
    class: ['wxc-search-bar', 'wxc-search-bar-' + _vm.theme],
    style: (_vm._px2rem(_vm.barStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('input', {
    class: ['search-bar-input', 'input-has-dep', 'search-bar-input-' + _vm.theme],
    attrs: {
      "disabled": _vm.disabled,
      "autofocus": _vm.autofocus,
      "return-key-type": _vm.returnKeyType,
      "type": _vm.inputType,
      "placeholder": _vm.placeholder,
      "data-evt-blur": "",
      "data-evt-focus": "",
      "data-evt-input": "",
      "data-evt-return": ""
    },
    domProps: {
      "value": _vm.value
    },
    nativeOn: {
      "blur": function($event) {
        $event.stopPropagation();
        return _vm.onBlur($event)
      },
      "focus": function($event) {
        $event.stopPropagation();
        return _vm.onFocus($event)
      },
      "input": function($event) {
        $event.stopPropagation();
        return _vm.onInput($event)
      },
      "return": function($event) {
        $event.stopPropagation();
        return _vm.onSubmit($event)
      }
    }
  }), _vm._v(" "), (_vm.disabled) ? _c('div', {
    staticClass: "disabled-input has-dep-disabled weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.inputDisabledClicked($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: " weex-ct weex-div",
    class: ['bar-dep', '.bar-dep-' + _vm.theme],
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.depClicked($event)
      }
    }
  }, [_c('p', {
    staticClass: "dep-text weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.depName))]), _vm._v(" "), _c('figure', {
    staticClass: "dep-arrow weex-el weex-image",
    attrs: {
      "src": _vm.arrowIcon,
      "aria-hidden": true,
      "data-img-src": _vm.arrowIcon,
      "weex-type": "image"
    }
  })]), _vm._v(" "), _c('figure', {
    staticClass: "search-bar-icon icon-has-dep weex-el weex-image",
    attrs: {
      "aria-hidden": true,
      "src": _vm.inputIcon,
      "data-img-src": _vm.inputIcon,
      "weex-type": "image"
    }
  })]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f20af96c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f20af96c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/wxc-searchbar/index.vue
// module id = 249
// module chunks = 0 1